import styled from 'styled-components';

export const Container = styled.div`
  max-width: 2200px;
  margin: 0 auto;
  overflow: hidden;
  padding: 0 24px;
  height: 100%;
`;
